import React, { useEffect } from "react";
import LegitimateInterest from "../LegitimateInterest";
import ConsentProcessing from "../ConsentProcessing";
import SubIdentitiesAliases from "../SubIdentitiesAliases";
import Sources from "../Sources";
import EmailActivity from "../EmailActivity/EmailActivity";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import useTracker from "../../../hooks/useTracker";
const DetailsTabs = ({
  activeTab,
  setActiveTab,
  refresh,
  details,
  loading,
  setLoading,
}) => {
  const dispatch = useDispatch();
  const { activeTabTracker } = useTracker();
  const activeTabs = useSelector((state) => state.TrackerReducer.active_tab);

  useEffect(() => {
    if (activeTabs == "") {
      setActiveTab(1);
    } else setActiveTab(activeTabs);
  }, []);
  return (
      <div className="pt-4 box-shadow" id="createModal">
        <div className="container-fluid px-0" role="document">
          <div className="d-flex justify-content-start align-items-end gap-2">
            <button
              type="button"
              className={
                activeTab === 1
                  ? `tabs-btn tabs-active`
                  : `tabs-btn`
              }
              onClick={() => {
                setActiveTab(1);

                activeTabTracker({
                  active_tab: 1,
                });
              }}
            >
              <FormattedMessage
                id="label.consent-processing"
                defaultMessage="Consent Processing"
              />
            </button>
            <button
              type="button"
              className={
                activeTab === 2
                  ? `tabs-btn tabs-active`
                  : `tabs-btn`
              }
              onClick={() => {
                setActiveTab(2);
                activeTabTracker({
                  active_tab: 2,
                });
              }}
            >
              <FormattedMessage
                id="label.legitimate-interest"
                defaultMessage="Legitimate Interest"
              />
            </button>
            <button
              type="button"
              className={
                activeTab === 3
                  ? `tabs-btn tabs-active`
                  : `tabs-btn`
              }
              onClick={() => {
                setActiveTab(3);
                activeTabTracker({
                  active_tab: 3,
                });
              }}
            >
              <FormattedMessage
                id="id.label.sub-ids-and-aliases"
                defaultMessage="Sub Identities & Aliases"
              />
            </button>
            <button
              type="button"
              className={
                activeTab === 4
                  ? `tabs-btn tabs-active`
                  : `tabs-btn`
              }
              onClick={() => {
                setActiveTab(4);
                activeTabTracker({
                  active_tab: 4,
                });
              }}
            >
              <FormattedMessage id="label.sources" defaultMessage="Sources" />
            </button>
            <button
              type="button"
              className={
                activeTab === 6
                  ? `tabs-btn tabs-active`
                  : `tabs-btn`
              }
              onClick={() => {
                setActiveTab(6);
                activeTabTracker({
                  active_tab: 6,
                });
              }}
            >
              <FormattedMessage
                id="id.tab.email.activity"
                defaultMessage="Email Activity"
              />
            </button>
          </div>
          {activeTab === 1 && (
            <ConsentProcessing
              refresh={refresh}
              details={details}
              loading={loading}
              setLoading={setLoading}
            />
          )}
          {activeTab === 2 && (
            <LegitimateInterest
              refresh={refresh}
              details={details}
              loading={loading}
              setLoading={setLoading}
            />
          )}
          {activeTab === 3 && (
            <SubIdentitiesAliases
              details={details}
              refresh={refresh}
              loading={loading}
            />
          )}
          {activeTab === 4 && <Sources details={details} loading={loading} />}
          {activeTab === 6 && (
            <EmailActivity details={details} loading={loading} />
          )}
        </div>
      </div>
  );
};

export default DetailsTabs;
